<template>
  <div class="pngPreview">
    <heading type="h1">PNG Preview</heading>
  </div>
</template>

<script>
import Heading from '@/components/Heading/heading'

export default {
  name: 'pngPreview',
  components: {
    Heading
  }
}
</script>

<style lang="scss">
    .pngPreview {
        padding-top: 40px;
        text-align: center;
        width:100%;
        height:100%;
        background-color: blue;
        color:white;
        position: absolute;
        top:0;
        left:0;
    }
</style>



// WEBPACK FOOTER //
// src/pages/dev/png-preview.vue